/* carte-sans-photo.js
   Permet les modeles de carte sans emplacement photo.

   Le module d'origine exige une photo pour tous les modeles : il calcule la
   position du cadre photo avant tout le reste et plante quand le champ
   imagezone du metaobjet est vide. Ce fichier fait deux choses :

   1. il remplace la zone photo absente par un carre de 2 px place dans le coin
      superieur gauche, ce qui evite l'erreur et reste invisible sur la carte ;
   2. il masque le bouton d'ajout de photo et prend la main sur l'ajout au
      panier pour ces modeles, en envoyant au serveur de rendu un payload de
      forme strictement identique a celui des autres cartes.

   Le serveur de rendu n'est pas modifie : il recoit toujours une image, ici un
   carre de 2 px a la couleur du papier. */

(function () {
  'use strict';

  var W = 1080, H = 1920;
  var RENDU = 'https://cardrender.onrender.com/render-card';
  var PIXEL = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAIAAAD91JpzAAAAFklEQVR42mP89ukNAwMDEwMDAwMDAwAiJALYOIFW1wAAAABJRU5ErkJggg==';

  var ZONE = {
    type: 'rect',
    shape: 'rect',
    x: 0,
    y: 0,
    width: 2 / W,
    height: 2 / H
  };

  /* ------------------------------------------------------------------
     1. neutraliser les zones photo absentes
     ------------------------------------------------------------------ */
  function preparerTemplates() {
    var T = window.TEMPLATES;
    if (!T) return;
    Object.keys(T).forEach(function (k) {
      if (!T[k].imageZone) {
        T[k].imageZone = Object.assign({}, ZONE);
        T[k].sansPhoto = true;
      }
    });
  }

  preparerTemplates();

  function modeleCourant() {
    var sel = document.getElementById('template');
    if (!sel || !window.TEMPLATES) return null;
    return window.TEMPLATES[sel.value] || null;
  }

  function sansPhoto(t) {
    return !!(t && t.sansPhoto);
  }

  /* ------------------------------------------------------------------
     2. masquer le bloc photo sur ces modeles
     ------------------------------------------------------------------ */
  function majInterface() {
    var t = modeleCourant();
    var cache = sansPhoto(t) ? 'none' : '';
    var bouton = document.querySelector('label.upload-btn');
    var masque = document.getElementById('imageMask');
    var conseil = document.querySelector('#custom-card-editor .small.muted');

    document.querySelectorAll('label[for="image"]').forEach(function (el) {
      el.style.display = cache;
    });
    if (bouton) bouton.style.display = cache;
    if (masque) masque.style.display = cache;
    if (conseil && sansPhoto(t)) {
      conseil.textContent = 'Ce modele se personnalise avec le prenom, les dates et votre message.';
    }
  }

  /* ------------------------------------------------------------------
     3. outils repris a l'identique du module d'origine
     ------------------------------------------------------------------ */
  function lirePolice(chaine, defaut) {
    return {
      weight: parseInt((chaine.match(/^\d+/) || ['400'])[0], 10),
      sizePx: parseInt((chaine.match(/(\d+)px/) || [null, defaut])[1], 10),
      family: chaine.replace(/^\d+\s+\d+px\s*/, '').trim()
    };
  }

  function lignesDeBase(el) {
    if (!el) return [];
    var toile = document.getElementById('previewCanvas');
    if (!toile) return [];
    var echelle = (toile.clientWidth || W) / W;
    var haut = toile.getBoundingClientRect().top;
    return Array.prototype.map.call(el.querySelectorAll('span'), function (s) {
      var r = s.getBoundingClientRect();
      var taille = parseFloat(window.getComputedStyle(s).fontSize);
      return Math.round((r.top + taille * 0.8 - haut) / echelle);
    });
  }

  function valeur(id) {
    var el = document.getElementById(id);
    return el ? el.value || '' : '';
  }

  function construirePayload(t) {
    var url = t.bg && t.bg.indexOf('http') === 0 ? t.bg : 'https:' + t.bg;
    return {
      background: { url: url, width: W, height: H },
      userImage: {
        dataUrl: PIXEL,
        width: 2,
        height: 2,
        realSize: { width: 2, height: 2 },
        offset: { x: 0, y: 0 }
      },
      crop: { x: 0, y: 0, width: 2, height: 2 },
      mask: null,
      target: { x: 0, y: 0, width: 2, height: 2 },
      imageZone: { x: 0, y: 0, width: 2 / W, height: 2 / H },
      texts: {
        name: {
          value: valeur('name'),
          font: lirePolice(t.nameFont, 80),
          color: t.nameColor,
          baselinesY: lignesDeBase(document.getElementById('overlayName'))
        },
        dates: {
          value: valeur('dates'),
          font: lirePolice(t.datesFont, 60),
          color: t.datesColor,
          baselinesY: lignesDeBase(document.getElementById('overlayDates'))
        },
        message: {
          value: valeur('message'),
          font: lirePolice(t.messageFont, 50),
          color: t.messageColor,
          baselinesY: lignesDeBase(document.getElementById('overlayMessage'))
        }
      },
      meta: {
        template: t.group_key,
        renderSize: { width: W, height: H }
      }
    };
  }

  function statut(texte, erreur) {
    var el = document.getElementById('status');
    if (!el) return;
    el.textContent = texte || '';
    el.style.color = erreur ? '#d9534f' : '#5cb85c';
  }

  /* ------------------------------------------------------------------
     4. reprendre la main sur l'ajout au panier
     ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var bouton = e.target && e.target.closest ? e.target.closest('#addToCart') : null;
    if (!bouton) return;

    var t = modeleCourant();
    if (!sansPhoto(t)) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    if (!valeur('name') && !valeur('dates') && !valeur('message')) {
      statut('Veuillez saisir au moins un texte.', true);
      return;
    }

    bouton.disabled = true;
    statut('Preparation de votre carte...');

    var payload = construirePayload(t);

    fetch(RENDU, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fileName: 'carte-' + Date.now() + '.jpg', payload: payload })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('rendu ' + r.status);
        return r.json();
      })
      .then(function (d) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: window.SHOPIFY_PRODUCT_VARIANT_ID,
              quantity: 1,
              properties: { image_id: d.imageId }
            }]
          })
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function (err) {
        console.error('[carte-sans-photo]', err);
        bouton.disabled = false;
        statut('Une erreur est survenue, merci de reessayer.', true);
      });
  }, true);

  /* ------------------------------------------------------------------
     5. suivre les changements de modele
     ------------------------------------------------------------------ */
  function brancher() {
    preparerTemplates();
    majInterface();
    ['template', 'groupCard'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && !el.dataset.sansPhotoBranche) {
        el.dataset.sansPhotoBranche = '1';
        el.addEventListener('change', function () {
          setTimeout(majInterface, 0);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', brancher);
  } else {
    brancher();
  }
  window.addEventListener('load', brancher);
})();
